import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const todoApiSlice = createApi({
  reducerPath: "todoApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://msi-server.herokuapp.com",
  }),
  tagTypes: ["Todos"],
  endpoints: (builder) => ({
    //end point to get all todo
    getFilteredTodos: builder.query({
      query: (arg) => {
        console.log(arg);
        const { status, color } = arg || {};
        let queryString = "";
        if (status === false || status === true)
          queryString += `completed=${status}`;
        if (color.length > 0)
          queryString += color.reduce((acc, cv) => {
            return (acc = acc + `&color=${cv}`);
          }, "");

        return `/todos?${queryString}`;
      },
      keepUnusedDataFor: 300,
      providesTags: ["Todos"],
    }),

    //end point to get no of incompleted  todo
    getNoOfIncompletedTodo: builder.query({
      query: () => `/todos`,
      transformResponse: (response) => {
        console.log(response);
        return response.filter((todo) => todo.completed === false).length;
      },
      providesTags: ["Todos"],
    }),

    //end point to add a todo in the db
    addTodo: builder.mutation({
      query: (body) => ({
        url: "/todos",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Todos"],
    }),
    //end point to change status/priority of a todo
    changeStatusOrPriorityOrText: builder.mutation({
      query: ({ body, id }) => ({
        url: `/todos/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["Todos"],
    }),
    //end point to delete a todo
    deleteTodo: builder.mutation({
      query: (id) => ({
        url: `/todos/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Todos"],
    }),
    //end point to complete all todo
    changeMultipleTodoStatus: builder.mutation({
      async queryFn(_, _queryApi, _extraOptions, baseQuery) {
        const result = await baseQuery({
          url: `https://msi-server.herokuapp.com/todos/`,
          method: "GET",
        });
        const idsOFIncompletedTodo = result?.data
          .filter((todo) => todo.completed !== true)
          .map((todo) => todo.id);

        if (idsOFIncompletedTodo.length <= 0)
          return { data: "No todo to be completed" };
        for (const id of idsOFIncompletedTodo) {
          const result = await baseQuery({
            url: `https://msi-server.herokuapp.com/todos/${id}/`,
            method: "PATCH",
            body: { completed: true },
          });
        }
        return {
          data: `${idsOFIncompletedTodo.length} Todos have been completed`,
        };
      },
      invalidatesTags: ["Todos"],
    }),
    //end point to clear all completed todo
    clearAllCompletedTodo: builder.mutation({
      async queryFn(_, _queryApi, _extraOptions, baseQuery) {
        const result = await baseQuery({
          url: `https://msi-server.herokuapp.com/todos/`,
          method: "GET",
        });
        const idsOFCompletedTodo = result?.data
          .filter((todo) => todo.completed === true)
          .map((todo) => todo.id);

        if (idsOFCompletedTodo.length <= 0)
          return { data: "No todo to be cleard" };
        for (const id of idsOFCompletedTodo) {
          await baseQuery({
            url: `https://msi-server.herokuapp.com/todos/${id}/`,
            method: "DELETE",
          });
        }
        return {
          data: `${idsOFCompletedTodo.length} todos have been cleared`,
        };
      },
      invalidatesTags: ["Todos"],
    }),
  }),
});

export const {
  useGetFilteredTodosQuery,
  useGetNoOfIncompletedTodoQuery,
  useAddTodoMutation,
  useChangeStatusOrPriorityOrTextMutation,
  useDeleteTodoMutation,
  useChangeMultipleTodoStatusMutation,
  useClearAllCompletedTodoMutation,
} = todoApiSlice;
